module.exports = __webpack_public_path__ + "static/media/sort-up.acdd06ce.svg";